/**
 * Обратная ссылка на сообщение обсуждения, из которого создана запись (УВ-02).
 */
import type { DiscussionOrigin as Origin } from '@epc/contracts';
import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { api } from '../lib/api';

export function DiscussionOriginBanner({
  toType,
  toId,
}: {
  toType: 'task' | 'psd_question' | 'psd_remark';
  toId: string;
}) {
  const q = useQuery({
    queryKey: ['discussions', 'origin', toType, toId],
    queryFn: () => api<Origin | null>('/discussions/origin', { query: { toType, toId } }),
  });
  if (!q.data) return null;
  const o = q.data;
  return (
    <p className="rounded-md bg-surface-2 px-3 py-2 text-[13px] text-ink-2">
      Создано из обсуждения:{' '}
      <Link to={o.path} className="font-medium text-ink underline-offset-4 hover:underline">
        {o.title}
      </Link>
      {o.bodyPreview ? <span className="mt-1 block truncate text-[12px]">«{o.bodyPreview}»</span> : null}
    </p>
  );
}
